import { render } from "./ModalDiff.vue?vue&type=template&id=37c467cc"
import script from "./ModalDiff.vue?vue&type=script&lang=js"
export * from "./ModalDiff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__